<form
  *ngIf="!!form && !!errors"
  class="date-filter"
  [formGroup]="form"
  [appForm]="errors.errors"
>
  <div class="title">
    {{ title }}
  </div>
  <app-start-end-datetime-form
    [form]="form"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [clearable]="clearable"
    (onBlur)="updateDateValue()"
  ></app-start-end-datetime-form>
</form>
